/**
 * This file is part of Iconika.
 *
 * Iconika is free software: you can redistribute it and/or modify it
 * under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 2 of the License, or
 * any later version.
 *
 * Iconika is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with Iconika.  If not, see <https://www.gnu.org/licenses/>.
 */
import { __ } from '@wordpress/i18n';

{
	document.querySelectorAll('.wp-block-iconika-timeline').forEach( el => {
		const buttonList = el.insertAdjacentElement( 'beforebegin', Object.assign( document.createElement( 'div' ), {
			className: 'wp-block-iconika-timeline__years',
		} ) );

		const underline = buttonList.appendChild( Object.assign( document.createElement( 'span' ), {
			className: 'wp-block-iconika-timeline__underline',
			innerText: '2000',
		} ) );

		const allButtons = [];
		function checkButton( button ) {
			for ( const b of allButtons ) {
				b.setAttribute( 'aria-checked', b === button );
			}
			underline.style.left = button.getBoundingClientRect().left + 'px';
			el.dataset.hasPrev = !button.matches(':first-of-type');
			el.dataset.hasNext = !button.matches(':last-of-type');
		}

		let first = true;
		const events = el.querySelectorAll( 'li[data-year]');
		const prefixId = 'event-' + Math.random().toString(36).substr(2, 10) + '-';
		events.forEach( li => {
			const button = buttonList.appendChild( Object.assign( document.createElement( 'button' ), {
				innerText: li.dataset.year,
				type: 'button',
			} ) );
			li.id = prefixId + li.dataset.year;
			button.setAttribute( 'aria-controls', li.id );
			button.addEventListener( 'click', () => {
				li.scrollIntoView( { block: 'nearest', inline: 'start', behavior: 'auto' } );
				checkButton( button );
			} );
			if ( first ) {
				first = false;
			} else {
				button.insertAdjacentElement( 'beforebegin', Object.assign( document.createElement( 'span' ), {
					innerText: '•',
				} ) );
			}
			allButtons.push( button );
		} );

		let prevScrollLeft = el.scrollLeft;
		function checkCurrentButton() {
			if (el.scrollLeft < prevScrollLeft) {
				const scrollLeft = el.scrollLeft + 10;
				for (const li of events) {
					if ( li.offsetLeft + li.offsetWidth > scrollLeft ) {
						checkButton( buttonList.querySelector(`button[aria-controls=${li.id}]`) );
						break;
					}
				}
			} else {
				const scrollLeft = el.scrollLeft - 10;
				for (const li of events) {
					if ( li.offsetLeft > scrollLeft ) {
						checkButton( buttonList.querySelector(`button[aria-controls=${li.id}]`) );
						break;
					}
				}
			}
			prevScrollLeft = el.scrollLeft;
		}

		el.addEventListener( 'scroll', checkCurrentButton );
		checkCurrentButton();

		const navigation = el.insertAdjacentElement( 'afterend', Object.assign( document.createElement( 'div' ), {
				className: 'wp-block-iconika-timeline__navigation',
		} ) );

		function createButton(label) {
			const button = navigation.insertAdjacentElement( 'beforeend', Object.assign( document.createElement( 'button' ), {
				type: 'button',
			} ) );

			button.insertAdjacentElement( 'beforeend', Object.assign( document.createElement( 'span' ), {
				className: 'screen-reader-text',
				innerText: label,
			} ) );

			return button;
		}

		const prevButton = createButton( 'Previous' );
		prevButton.addEventListener( 'click', (event) => {
			const b = buttonList.querySelector('button[aria-checked=true]:not(:first-of-type)');
			b?.previousElementSibling?.previousElementSibling?.click();
		});

		// Spacer
		navigation.insertAdjacentElement( 'beforeend', document.createElement( 'span' ) );

		const nextButton = createButton( 'Next' );
		nextButton.addEventListener( 'click', (event) => {
			const b = buttonList.querySelector('button[aria-checked=true]:not(:last-child)');
			b?.nextElementSibling?.nextElementSibling?.click();
		});
	} );
}
